import { render, staticRenderFns } from "./DocumentationPanel.vue?vue&type=template&id=3624a5f4&scoped=true&"
import script from "./DocumentationPanel.vue?vue&type=script&lang=js&"
export * from "./DocumentationPanel.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPanel.vue?vue&type=style&index=0&id=3624a5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3624a5f4",
  null
  
)

export default component.exports